import { render, staticRenderFns } from "./NftDashboard.vue?vue&type=template&id=7348c198&scoped=true"
import script from "./NftDashboard.vue?vue&type=script&lang=js"
export * from "./NftDashboard.vue?vue&type=script&lang=js"
import style0 from "./NftDashboard.vue?vue&type=style&index=0&id=7348c198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348c198",
  null
  
)

export default component.exports